module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6r7n9n3n-048cb440eb02de5f77e49eb13b5d15ef.svg";